export default "__VITE_ASSET__9$bC6vlb__"